// extracted by mini-css-extract-plugin
module.exports = {"tab-container":"walkthroughTab_tab-container__2vCYB","symbol-container":"walkthroughTab_symbol-container__vusoH","tab-name":"walkthroughTab_tab-name__2FylA"};